/* ============================================================
   Luna Store — Vanilla JS Interactivity
   ============================================================ */

(function () {
  'use strict';

  /* ── Cart Drawer ──────────────────────────────────────────── */
  const cartBackdrop = document.querySelector('.luna-cart-backdrop');
  const cartDrawer = document.querySelector('.luna-cart-drawer');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCloses = document.querySelectorAll('[data-cart-close]');
  const cartBadge = document.querySelector('.luna-cart-toggle__badge');

  function openCart() {
    cartBackdrop?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartBackdrop?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggles.forEach((btn) => btn.addEventListener('click', openCart));
  cartCloses.forEach((btn) => btn.addEventListener('click', closeCart));
  cartBackdrop?.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  /* ── Add to Cart (Shopify AJAX API) ──────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('added');
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Adicionado!';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (res.ok) {
        updateCartUI();
        setTimeout(() => {
          btn.classList.remove('added');
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 1800);
      } else {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }
    } catch {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }
  });

  /* ── Update Cart UI ──────────────────────────────────────── */
  async function updateCartUI() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();

      /* Badge */
      if (cartBadge) {
        if (cart.item_count > 0) {
          cartBadge.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          cartBadge.hidden = false;
        } else {
          cartBadge.hidden = true;
        }
      }

      /* Drawer items */
      const itemsContainer = document.querySelector('.luna-cart-drawer__items');
      const footerEl = document.querySelector('.luna-cart-drawer__footer');
      const emptyEl = document.querySelector('.luna-cart-empty');

      if (!itemsContainer) return;

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'flex';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';

      itemsContainer.innerHTML = cart.items.map((item) => `
        <div class="luna-cart-item" data-cart-item="${item.key}">
          <div class="luna-cart-item__image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="luna-cart-item__details">
            <p class="luna-cart-item__name">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="luna-cart-item__variant">${item.variant_title}</p>` : ''}
            <div class="luna-cart-item__qty">
              <button class="luna-cart-item__qty-btn" data-qty-change="-1" data-key="${item.key}" aria-label="Diminuir quantidade">−</button>
              <span class="luna-cart-item__qty-num">${item.quantity}</span>
              <button class="luna-cart-item__qty-btn" data-qty-change="1" data-key="${item.key}" aria-label="Aumentar quantidade">+</button>
            </div>
            <p class="luna-cart-item__price">${formatBRL((item.price / 100) * item.quantity)}</p>
          </div>
          <button class="luna-cart-item__remove" data-remove-item="${item.key}" aria-label="Remover item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </button>
        </div>
      `).join('');

      /* Subtotal */
      const subtotalEl = document.querySelector('.luna-cart-drawer__subtotal-price');
      if (subtotalEl) subtotalEl.textContent = formatBRL(cart.total_price / 100);
    } catch { /* ignore */ }
  }

  /* ── Cart quantity change / remove ───────────────────────── */
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-remove-item]');

    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const delta = Number(qtyBtn.dataset.qtyChange);
      const qtyEl = qtyBtn.parentElement.querySelector('.luna-cart-item__qty-num');
      const currentQty = Number(qtyEl?.textContent || 1);
      const newQty = currentQty + delta;

      if (newQty <= 0) {
        await cartChange(key, 0);
      } else {
        qtyEl.textContent = newQty;
        await cartChange(key, newQty);
      }
      updateCartUI();
    }

    if (removeBtn) {
      const key = removeBtn.dataset.removeItem;
      await cartChange(key, 0);
      updateCartUI();
    }
  });

  async function cartChange(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
    } catch { /* ignore */ }
  }

  /* ── Image Carousel ──────────────────────────────────────── */
  document.querySelectorAll('.luna-carousel').forEach((carousel) => {
    const slides = carousel.querySelectorAll('.luna-carousel__slide');
    const dots = carousel.querySelectorAll('.luna-carousel__dot');
    const prevBtn = carousel.querySelector('.luna-carousel__arrow--prev');
    const nextBtn = carousel.querySelector('.luna-carousel__arrow--next');
    let current = 0;
    let startX = 0;
    let isDragging = false;

    function goTo(index) {
      slides[current]?.classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('active');
      dots[current]?.classList.add('active');
    }

    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    /* Swipe */
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    /* Mouse drag */
    carousel.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      e.preventDefault();
    });
    carousel.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    });
  });

  /* ── Variant Selector ────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.luna-variant-btn');
    if (!btn) return;

    const group = btn.closest('.luna-variants');
    if (!group) return;

    group.querySelectorAll('.luna-variant-btn').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    const productId = btn.dataset.productId;
    const variantId = btn.dataset.variantId;
    const variantName = btn.dataset.variantName;

    /* Update hidden input */
    const form = btn.closest('form');
    const input = form?.querySelector('input[name="id"]');
    if (input && variantId) input.value = variantId;

    /* Update add-to-cart button data */
    const addBtn = btn.closest('.luna-product-card, .luna-product-page__info')
      ?.querySelector('[data-add-to-cart]');
    if (addBtn && variantId) addBtn.dataset.variantId = variantId;

    /* Update availability */
    if (addBtn && btn.dataset.variantAvailable !== undefined) {
      addBtn.disabled = btn.dataset.variantAvailable !== 'true';
    }

    /* Update price on product cards */
    const priceDisplay = btn.closest('.luna-product-card')?.querySelector('[data-price-display]');
    if (priceDisplay && btn.dataset.variantPrice) {
      const priceEl = priceDisplay.querySelector('.luna-price__current');
      if (priceEl) priceEl.textContent = btn.dataset.variantPrice;

      const origEl = priceDisplay.querySelector('.luna-price__original');
      const discEl = priceDisplay.querySelector('.luna-price__discount');
      if (btn.dataset.variantCompare && btn.dataset.variantCompare !== '' && btn.dataset.variantCompare !== btn.dataset.variantPrice) {
        if (origEl) { origEl.textContent = btn.dataset.variantCompare; origEl.style.display = ''; }
        if (discEl) { const c = parseFloat(btn.dataset.variantCompare.replace(/[^\d,]/g, '').replace(',', '.')); const p = parseFloat(btn.dataset.variantPrice.replace(/[^\d,]/g, '').replace(',', '.')); if (c > p) { discEl.textContent = '-' + Math.round((c - p) / c * 100) + '%'; discEl.style.display = ''; } }
      } else {
        if (origEl) origEl.style.display = 'none';
        if (discEl) discEl.style.display = 'none';
      }
    }

    /* Update price on product page */
    const pagePrice = btn.closest('.luna-product-page__info')?.querySelector('[data-product-page-price]');
    if (pagePrice && btn.dataset.variantPrice) {
      pagePrice.textContent = btn.dataset.variantAvailable === 'true'
        ? (pagePrice.textContent.includes('—') ? 'Adicionar ao carrinho — ' + btn.dataset.variantPrice : pagePrice.textContent.replace(/—.*/, '— ' + btn.dataset.variantPrice))
        : 'Esgotado';
    }

    /* Update "Buy now" link */
    const buyNow = btn.closest('.luna-product-card, .luna-product-page__info')
      ?.querySelector('[data-buy-now]');
    if (buyNow && variantId) {
      buyNow.href = '/checkout?variant=' + variantId;
      buyNow.style.pointerEvents = btn.dataset.variantAvailable === 'true' ? '' : 'none';
      buyNow.style.opacity = btn.dataset.variantAvailable === 'true' ? '' : '0.5';
    }

    /* Update URL without reload */
    if (variantId && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  });

  /* ── Scroll reveal (IntersectionObserver) ────────────────── */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    revealEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = `opacity 0.7s ease ${i * 0.12}s, transform 0.7s ease ${i * 0.12}s`;
      observer.observe(el);
    });
  }

  /* ── Helpers ─────────────────────────────────────────────── */
  function formatBRL(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  /* ============================================================
     VISUAL EFFECTS
     ============================================================ */

  const isDesktop = window.matchMedia('(min-width: 769px)').matches;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Firefly Particles ─────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const container = document.createElement('div');
    container.className = 'luna-fireflies';
    container.setAttribute('aria-hidden', 'true');
    document.body.appendChild(container);

    const fireflyCount = 10;
    for (let i = 0; i < fireflyCount; i++) {
      const el = document.createElement('div');
      el.className = 'luna-firefly';
      el.style.left = Math.random() * 100 + '%';
      el.style.top = 40 + Math.random() * 50 + '%';
      el.style.setProperty('--duration', (10 + Math.random() * 8) + 's');
      el.style.setProperty('--delay', (Math.random() * 10) + 's');
      el.style.setProperty('--tx', (Math.random() * 160 - 80) + 'px');
      el.style.setProperty('--ty', -(60 + Math.random() * 140) + 'px');
      el.style.setProperty('--tx2', (Math.random() * 120 - 60) + 'px');
      el.style.setProperty('--ty2', -(100 + Math.random() * 160) + 'px');
      container.appendChild(el);
    }
  }

  /* ── Cursor Glow Trail ─────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const glow = document.createElement('div');
    glow.className = 'luna-cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);

    let mouseX = 0, mouseY = 0;
    let glowX = 0, glowY = 0;
    let active = false;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!active) {
        active = true;
        glow.classList.add('active');
      }
    });

    document.addEventListener('mouseleave', () => {
      active = false;
      glow.classList.remove('active');
    });

    function animateGlow() {
      glowX += (mouseX - glowX) * 0.12;
      glowY += (mouseY - glowY) * 0.12;
      glow.style.left = glowX + 'px';
      glow.style.top = glowY + 'px';
      requestAnimationFrame(animateGlow);
    }
    animateGlow();
  }

  /* ── Scroll Reveal (Enhanced) ──────────────────────────── */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('[data-reveal]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -80px 0px' }
    );
    revealEls.forEach((el, i) => {
      el.style.transitionDelay = (i * 0.15) + 's';
      observer.observe(el);
    });
  }

  /* ── Ripple Effect on Buttons ───────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.luna-add-to-cart, .luna-product-page__add-btn, .luna-cart-drawer__checkout');
    if (!btn || prefersReducedMotion) return;

    const rect = btn.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'luna-ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  });

  /* ── Hero Parallax ─────────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const heroBg = document.querySelector('.luna-hero__bg');
    const heroInner = document.querySelector('.luna-hero__inner');
    if (heroBg && heroInner) {
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            const heroH = heroBg.parentElement.offsetHeight;
            if (scrollY < heroH) {
              heroBg.style.transform = 'translateY(' + (scrollY * 0.25) + 'px)';
              heroInner.style.transform = 'translateY(' + (scrollY * 0.08) + 'px)';
              heroInner.style.opacity = 1 - scrollY / heroH * 0.5;
            }
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  /* ── Init cart on load ───────────────────────────────────── */
  updateCartUI();
})();
